<template>
  <div v-if="activeOptions.length" class="d-flex flex-wrap align-center ga-2 mb-3">
    <v-chip v-for="option in activeOptions" :key="`${option.groupKey}-${option.value}`" closable variant="tonal"
      color="brand-color" size="small" rounded="lg" :prepend-icon="option.icon"
      @click:close="toggle(option.groupKey, option.value, false)">
      {{ option.title }}
    </v-chip>

    <v-btn variant="tonal" color="error" density="comfortable" prepend-icon="mdi-filter-remove" @click="clearAll">
      Clear all
    </v-btn>
  </div>
</template>

<script>
import userFiltersMixin from '@/mixins/user/filters'

export default {
  name: 'UserFilterChips',
  mixins: [userFiltersMixin]
}
</script>
